import { Theme } from '@/contexts/theme-context';

export const COMPOSER_PADDING_VERTICAL = 10;
export const INPUT_TOOLBAR_PADDING_VERTICAL = 8;

// TextInput height without padding
export const MAX_COMPOSER_HEIGHT = 120;
export const MIN_COMPOSER_HEIGHT = 20;

// TextInput height with padding
export const COMPOSER_HEIGHT =
  MIN_COMPOSER_HEIGHT + 2 * COMPOSER_PADDING_VERTICAL;

export const MIN_INPUT_TOOLBAR_HEIGHT =
  COMPOSER_HEIGHT + 2 * INPUT_TOOLBAR_PADDING_VERTICAL;

export const INPUT_TOOLBAR_HIT_SLOP = {
  left: 8,
  right: 8,
};

export const getChatMessageBorderColor = (theme: Theme) =>
  `${theme.colors.black}20`;

// Ensures spacing between avatar and message bubble aligns with previous messages
// https://github.com/FaridSafi/react-native-gifted-chat/blob/2b9d5dca69a21d8fc0efe24d73f1ca36596a7b99/src/Avatar.tsx#L24-L25
export const AVATAR_DIAMETER = 36;
export const CASEY_ID = 'CASEY_ID';
export const LOADING_MESSAGE_ID = 'LOADING_MESSAGE';

const AVATAR_PADDING = 12;
export const DEFAULT_USERNAME_DISTANCE_IN_PX = AVATAR_DIAMETER + AVATAR_PADDING;
